var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoFuncaoMedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-funcao-media",
    transform: "translate(-352 -905)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m\\xE9dia",
    transform: "translate(361 910)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1259",
    "data-name": "Grupo 1259"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1258",
    "data-name": "Grupo 1258"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_745",
    "data-name": "Caminho 745",
    d: "M39.928,0H1.736a1.736,1.736,0,1,0,0,3.472H39.927a1.736,1.736,0,0,0,0-3.472Z",
    transform: "translate(2.456 8.338) rotate(45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_748",
    "data-name": "Caminho 748",
    d: "M39.926,3.472H1.736A1.736,1.736,0,1,1,1.736,0h38.19a1.736,1.736,0,0,1,0,3.472Z",
    transform: "translate(31.916 10.794) rotate(135)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_749",
    "data-name": "Caminho 749",
    d: "M30.586,3.472H1.33A1.574,1.574,0,0,1,0,1.737,1.574,1.574,0,0,1,1.33,0H30.586a1.574,1.574,0,0,1,1.33,1.736A1.574,1.574,0,0,1,30.586,3.472Z",
    transform: "translate(31.916 3.473) rotate(180)"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_444",
    "data-name": "Ret\\xE2ngulo 444",
    width: 50,
    height: 50,
    transform: "translate(352 905)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFuncaoMedia);
export default __webpack_public_path__ + "static/media/ico-funcao-media.752085e3.svg";
export { ForwardRef as ReactComponent };